import { useTranslation } from 'react-i18next'

import { Button, Icon, Modal, Typography } from '@matillion/component-library'

import classes from './FolderLimitReachedModal.module.scss'

export interface FolderLimitReachedModalProps {
  onDismiss: () => void
}

const FolderLimitReachedModal = ({
  onDismiss
}: FolderLimitReachedModalProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'create-folder.limit-modal'
  })

  return (
    <Modal
      size="mid"
      setFocus={false}
      onCancel={onDismiss}
      disableBackdropClick
      id="folder-limit-dialog"
      className={classes.Modal}
      data-testid="folder-limit-modal"
      ariaLabelledBy="folder-limit-title"
    >
      <Icon.Warning className={classes.Icon} />

      <Typography format="tm" className={classes.Title}>
        {t('title')}
      </Typography>

      <Typography className={classes.Description}>
        {t('description')}
      </Typography>

      <Button
        alt="primary"
        text={t('close')}
        onClick={onDismiss}
        className={classes.Dismiss}
        id="folder-limit-modal-dismiss"
        data-testid="folder-limit-modal-dismiss"
      />
    </Modal>
  )
}

export default FolderLimitReachedModal
